"use client";

import { parentScrollToTheTop } from "@hudson/ui/lib/utils";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export default function ScrollParentUpOnPageChange() {
  const [parentScroll, setParentScroll] = useState(0);
  const pathname = usePathname();

  // Scroll parent to top on page change.
  useEffect(() => {
    if (parentScroll == 0) {
      setParentScroll(1);
      return;
    } else parentScrollToTheTop();
  }, [pathname]);

  return null;
}
